import Service from "./Service";
// eslint-disable-next-line import/no-anonymous-default-export
export default {
    list: Service
}